import { useSettingsState } from '~/atoms/SettingsState'
import { canSendNotification, sendNotification } from '~/utils/notifications'

export const useNotifications = () => {
  const {
    settings: {
      notifications: { hasNewTextSound },
    },
  } = useSettingsState()

  const requestPermission = () => {
    if (canSendNotification()) return Notification.requestPermission()
  }

  const sendSampleNotification = () => {
    sendNotification({
      title: 'Notifications are enabled!',
      body: 'Mango Notifications will help you stay up to date with your customers.',
      playSound: hasNewTextSound,
    })
  }

  return {
    hasGranted: canSendNotification() && Notification.permission === 'granted',
    requestPermission,
    sendSampleNotification,
    sendNotification: ({
      title,
      body,
      onClick,
    }: {
      title: string
      body: string
      onClick?: () => void
    }) => {
      sendNotification({ title, body, playSound: hasNewTextSound, onClick })
    },
  }
}
